/*
 * Copyright (C) 2018 - 2025 Entgra (Pvt) Ltd, Inc - All Rights Reserved.
 *
 * Unauthorised copying/redistribution of this file, via any medium is strictly prohibited.
 *
 * Licensed under the Entgra Commercial License, Version 1.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *       https://entgra.io/licenses/entgra-commercial/1.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import { message, notification } from 'antd';
import config from '../../../public/conf/config.json';

export const handleApiError = (
  error,
  errorMessage,
  t,
  customizedErrorString = null,
) => {
  const errorResponseStatus = [400, 409];
  if (Object.prototype.hasOwnProperty.call(error, 'response')) {
    if (error.response.status === 401) {
      message.error(t('api_notLoggedInError'));
      const redirectUrl = encodeURI(window.location.href);
      window.location =
        window.location.origin +
        config.serverConfig.ssoLoginUri +
        `?redirect=${redirectUrl}`;
    } else if (customizedErrorString) {
      errorMessage = t(
        `${error.response.status + ' : ' + customizedErrorString}`,
      );
    } else if (errorResponseStatus.includes(error.response.status)) {
      errorMessage = error.response.data.data;
    }
  } else if (!errorMessage) {
    errorMessage = t('api_errorUnknown');
  }

  const notificationType =
    error.response && error.response.status === 409 ? 'warning' : 'error';

  notification[notificationType]({
    message: t('api_errorMsg'),
    duration: 10,
    description: errorMessage,
  });
};

export const handleApiSuccess = (
  successDescription,
  notificationDuration = 10,
) => {
  notification.success({
    duration: notificationDuration,
    description: successDescription,
  });
};
